// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter,.page-leave-to{opacity:0;transform:translateY(-30px)}.page-enter-active{transition:all .8s cubic-bezier(.56,-.01,.21,1.02)}.page-leave-active{transition:all .5s cubic-bezier(1,.5,.8,1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
